import React from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'uikit/loaders';
import { NavToggle } from 'uikit/navigation';

import getNavToggleTabs from '../helpers/getNavToggleTabs';

import VideosBrowseContainer from '../containers/videosBrowseContainer';
import VideoLiveAndUpcoming from './videoLiveAndUpcoming';

import styles from '../styles/videos.module.scss';

const Videos = ({
  browse,
  isLoading,
  liveAndUpcoming = [],
}) => (
  <>
    <NavToggle selectedValue="home" tabs={getNavToggleTabs()} />
    {isLoading
      ? <Loading className={styles.loader} />
      : (
        <div className={styles.content}>
          {liveAndUpcoming?.length > 0
          && (
            <VideoLiveAndUpcoming
              liveAndUpcoming={liveAndUpcoming}
              isLoading={isLoading}
            />
          )}
          <VideosBrowseContainer
            browse={browse}
            isLoading={isLoading}
          />
        </div>
      )}
  </>
);

Videos.propTypes = {
  browse: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  liveAndUpcoming: PropTypes.arrayOf(PropTypes.shape({})),
};

export default React.memo(Videos);
